module.exports = __webpack_public_path__ + "img/guizhouHints_17.59aa918f.jpg";